import React from 'react';
import { ArrowRight } from '../../../components';
import { Link } from './PrimaryLink.styles';
export function PrimaryLink({ url, text, onClick, tabIndex }) {
    return (React.createElement(Link, { href: url, onClick: onClick, tabIndex: tabIndex },
        text,
        React.createElement(ArrowRight, { color: "B300" })));
}
//# sourceMappingURL=PrimaryLink.js.map